<template>
	<div class="ModuleBox">
		<ComponentsLogin :onShow="LoginVisible" @onLogin="RefreshMemberInfo" @onHide="LoginHide" @onRegister="RegisterShow" @onResetPassword="ResetPasswordShow"/>
		<ComponentsRegister :onShow="RegisterVisible" @onHide="RegisterHide" @onBack="RegisterBack"/>
		<ComponentsResetPassword :onShow="ResetPasswordVisible" @onHide="ResetPasswordHide" @onBack="ResetPasswordBack"/>
		<ComponentsExchangePopover :onShow="ExchangePopoverVisible" @onHide="ExchangePopoverHide" />
		<div class="ModuleBoxTop">
			<div class="ModuleBoxTopBackground">
				<div class="ModuleBoxTopBackgroundElement1">
					<el-image :src="ImageElement1Url" fit="scale-down" />
				</div>
			</div>
			<div class="ModuleBoxTopBody">
				<div class="ModuleBoxTopBodyBody">
					<div class="ModuleBoxTopBodyBodyLogo">
						<el-image :src="ImageLogoUrl" fit="scale-down" />
					</div>
					<div class="ModuleBoxTopBodyBodyMy">
						<div class="ModuleBoxTopBodyBodyMyBackground" v-if="Token && Info?.Avatar"></div>
						<el-popover
							v-if="Token"
							popper-class="ModuleBoxTopBodyBodyMyPopover"
							placement="bottom"
							width="auto"
							trigger="hover"
						>
							<template #reference>
								<div class="ModuleBoxTopBodyBodyMyAvatar" @click="onClickMy()" :style="Info.Avatar?'border-radius:100%;':'border-radius:0%;'">
									<el-image :src="Info.Avatar?Info.Avatar:ImageMyIconUrl" :fit="Info.Avatar?'cover':'scale-down'" />
								</div>
							</template>

							<div class="ModuleBoxTopBodyBodyMyPopoverInfo">
								<div class="ModuleBoxTopBodyBodyMyPopoverInfoAvatar">
									<el-image :src="Info.Avatar?Info.Avatar:ImageMyIconUrl" :fit="Info.Avatar?'cover':'scale-down'" :style="Info.Avatar?' width: 100%;height: 100%;':' width: 50%;height: 50%;'"/>
								</div>
								<div class="ModuleBoxTopBodyBodyMyPopoverInfoNickname">{{Info.Nickname?Info.Nickname:'-'}}</div>
								<div class="ModuleBoxTopBodyBodyMyPopoverInfoInBtn" @click="onClickMy()">进入账号</div>
								<div class="ModuleBoxTopBodyBodyMyPopoverInfoOutBtn" @click="onOut()">退出账号</div>
							</div>
						</el-popover>
						<div class="ModuleBoxTopBodyBodyMyAvatar" @click="onClickMy()" v-else style="border-radius:0;">
							<el-image :src="ImageMyIconUrl" fit="scale-down" />
						</div>
					</div>

					<div class="ModuleBoxTopBodyBodySearch" @click="ToPath('/Search')">
						<el-image :src="ImageSearchIconUrl" fit="scale-down" />
					</div>
					<div class="ModuleBoxTopBodyBodyNav">
						<ul>
							<li v-for="Item in NavData" :key="Item">
								<div class="ModuleBoxTopBodyBodyNavTitle" @click="ToPath(Item.Path)" :style="this.$route.path.includes('/Archives') && Item.Path == '/'?'font-weight:bold':Item.Path == '/'?this.$route.path == Item.Path?'font-weight:bold;':'font-weight:normal;':this.$route.path.includes(Item.Path)?'font-weight:bold;':'font-weight:normal;'">{{Item.Title}}</div>
								<div class="ModuleBoxTopBodyBodyNavSelect">
									<div class="ModuleBoxTopBodyBodyNavSelectTop">
										<div class="ModuleBoxTopBodyBodyNavSelectTopBody" :style="this.$route.path.includes('/Archives') && Item.Path == '/'?'width: 25%;':Item.Path == '/'?this.$route.path == Item.Path?'width: 25%;':'':this.$route.path.includes(Item.Path)?'width: 25%;':''"></div>
									</div>
									<div class="ModuleBoxTopBodyBodyNavSelectBottom">
										<div class="ModuleBoxTopBodyBodyNavSelectBottomBody" :style="this.$route.path.includes('/Archives') && Item.Path == '/'?'width: 100%;':Item.Path == '/'?this.$route.path == Item.Path?'width: 100%;':'':this.$route.path.includes(Item.Path)?'width: 100%;':''"></div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
